import React from 'react';
import Form from './components/Form/Form';
import { ModalWindows } from './components/ModalWindows';
import EditDeviceState from './editDeviceState/EditDeviceState';

const EditDevicePage: React.FC = () => {
	return (
		<EditDeviceState>
			<Form />
			<ModalWindows />
		</EditDeviceState>
	);
};

export default EditDevicePage;
